import {interopDefault} from '@/utils/helpers'
const TourPage = () => interopDefault(import('~/pages/tours/TourPage'))
const TourSearchPage = () => interopDefault(import('~/pages/tours/TourSearchPage'))
const TourBookingPage = () => interopDefault(import('~/pages/tours/TourBookingPage'))
const TourConfirmationPage = () => interopDefault(import('~/pages/tours/TourConfirmationPage'))

export default [
    {
        path: '/search/tour',
        component: TourSearchPage,
        name: 'tourSearch',
        meta: {
            unwrapped: true,
        },
    },
    {
        path: '/tour',
        component: TourPage,
        name: 'tour',
        meta: {
            unwrapped: true,
            validate: route => !!route.query.packageTourId,
        },
    },
    {
        path: '/tour/booking',
        component: TourBookingPage,
        name: 'tourBooking',
        meta: {
            validate: route => !!route.query.offerKey,
        },
    },
    {
        path: '/tour/confirmation',
        component: TourConfirmationPage,
        name: 'tourConfirmation',
        meta: {
            unwrapped: true,
        },
    },
]
